import { trackAmplitudeEvent } from '@/modules/home/helpers/track-amplitude-event';

export function trackTransactionDetailsEvent(transactionType = '') {
  trackAmplitudeEvent({
    page_screen_section: 'last_transactions',
    event_type: 'click',
    event_name: 'detail_transaction',
    event_target: transactionType
  });
}

export function trackViewMoreTransactionsEvent() {
  trackAmplitudeEvent({
    page_screen_section: 'last_transactions',
    event_type: 'click',
    event_name: 'view_more_transactions'
  });
}

export function trackTransactionErrorLoad() {
  trackAmplitudeEvent({
    event_type: 'load',
    event_name: 'view_error_movimentation'
  });
}

export function trackReloadTransactionErrorClick() {
  trackAmplitudeEvent({
    event_type: 'click',
    page_screen_section: 'body',
    event_name: 'try_again_error_movimentation',
    event_target: 'Tentar novamente'
  });
}
